import React from 'react';

import decoratorImg from '../../images/decorator.svg';

const Decorator = (): JSX.Element => (
    <img src={decoratorImg} alt="an art deco style gold decorator" />
);

export default Decorator;
